import React, {useEffect} from "react"

import BannerSlider from "./bannerSlider";
import WhyChoose from "./whyChoose";
import Offers from "./offers";
import HowitWork from "./howItWork";
import OurVehicles from "./ourVehicles";
import Aboutskycars from "./aboutSkycars";
import FaqBox from "./faqbox";
import Footer from "../../components/footer";
import HomeSearchBox from "./homeSearchBox";
import Testimonials from "./Testimonials";
 
 //for redux and saga
//  import { connect } from 'react-redux';



const Home = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
    return (
        <div className="main">
            <BannerSlider />
            <HomeSearchBox />
            <WhyChoose />
            <Offers />
            <HowitWork />
            <OurVehicles />
            <Aboutskycars />
            <Testimonials />
            <FaqBox />
            <Footer  />
        </div>
        
    );  
  }
  


export default Home;


// const mapStateToProps = ({ authUser, settings }) => {
//     const { currentUser } = authUser;
//     const { locale } = settings;
//     return { currentUser, locale };
//   };
//   const mapActionsToProps = {};
  
//   export default connect(mapStateToProps, mapActionsToProps)(App);